import axios from "axios";
import { showDialog } from "vant";

let baseURL = process.env.VUE_APP_BASE_API;

if( process.env.NODE_ENV === 'development'){
	baseURL = `${baseURL}/api`;
}

const service = axios.create({
  baseURL: `${baseURL}/app/index.php?i=2&m=zh_jdgjb&c=entry&a=wxapp`,
  timeout: 20000
});

service.interceptors.request.use(
  config => {
    if (config.method.toUpperCase() === "GET") {
      config.url = config.url.replace(/[?&][\w]*=/g, query => {
        return query.replace(/[A-Z]/g, el => `_${el.toLowerCase()}`);
      });
    } else if (
      /POST|PUT|DELETE/.test(config.method.toUpperCase()) &&
      config.data
    ) {
      if (config.data instanceof FormData) {
        Object.assign(config.headers, {
          "Content-Type": "multipart/form-data"
        });
      } else {
        config.data = JSON.parse(
          JSON.stringify(config.data).replace(/"\w*":/g, params => {
            return params.replace(/[A-Z]/g, el => `_${el.toLowerCase()}`);
          })
        );
      }
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers["x-token"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.data) {
      const json = JSON.parse(
        JSON.stringify(response.data).replace(/"\w*":/g, value => {
          return value.replace(/_(\w)/g, ($0, $1) => $1.toUpperCase());
        })
      );
      response.data = json instanceof Array ? [...json] : { ...json };
    }
    const { errno, message } = response.data
    if (errno !== 0) {
      showDialog({
        title: '系统提示',
        message,
      }).then(() => {
        // on close
      });
      return Promise.reject(new Error(message || "Error"));
    }
    return response.data;
  },
  async e => {
    showDialog({
      title: '系统异常',
      message: e.message,
      theme: 'round-button',
    }).then(() => {
      // on close
    });
    return Promise.reject(e);
  }
);

export default service;
